import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FadeInSection from "./FadeInSection";

const isHorizontal = window.innerWidth < 600;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  if (isHorizontal) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  } else {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  if (isHorizontal) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`
    };
  } else {
    return {
      id: `vertical-tab-${index}`
    };
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "theme.palette.background.paper",
    display: "flex",
    height: 300
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}));

const JobList = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const experienceItems = {
    "University of Illinois Chicago": {
      jobTitle: "Undergraduate/Graduate Teaching Assistant @",
      duration: "JAN 2022 - PRESENT",
      desc: [
        "Design and led weekly lab sections, including content creation, lab recording, and student support, while developing auto - grader scripts for efficient grading",
        "Collaborated with faculty to enhance course materials and teaching strategies, contributing to departmental academic growth and analyzing student participation for course improvement",
        "Offered tailored student assistance through Piazza, discussion sessions, and office hours, focusing on exam preparation and academic inquiries"
      ]
    },
    "UIC BEI Lab": {
      jobTitle: "Web developer, Automation Engineer @",
      duration: "JUN 2023 - DEC 2023",
      desc: [
        "Developed a responsive website for UIC BEI Lab with HTML, CSS, JavaScript, and React.js",
        "Developed an automated pipeline for running lab’s experiments on EnergyPlus using Python which reduced the manual work by 70% ",
        "Implementedsystemsforstreamlineddataprocessing,deliveryandautomateddatamanagementwithGoogleCloudAPIs",
        "Created a tool using Zillow APIs for generating housing information reports from specified zip codes or city names"
      ]
    },
    CBBEL: {
      jobTitle: "Intern Software Developer @",
      duration: "MAY 2022 - JUNE 2022",
      desc: [
        "CBBEL: Christopher B. Burke Engineering",
        "Participating in development of the ADA Design Ramp Tool project - a computational aid for engineers in designing sidewalks quickly and conveniently",
        "Support, give ideas to redesign the interface",
        "Using HTML, CSS and JavaScript"
      ]
    },
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation={!isHorizontal ? "vertical" : null}
        variant={isHorizontal ? "fullWidth" : "scrollable"}
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        {Object.keys(experienceItems).map((key, i) => (
          <Tab label={isHorizontal ? `0${i}.` : key} {...a11yProps(i)} />
        ))}
      </Tabs>
      {Object.keys(experienceItems).map((key, i) => (
        <TabPanel value={value} index={i}>
          <span className="joblist-job-title">
            {experienceItems[key]["jobTitle"] + " "}
          </span>
          <span className="joblist-job-company">{key}</span>
          <div className="joblist-duration">
            {experienceItems[key]["duration"]}
          </div>
          <ul className="job-description">
            {experienceItems[key]["desc"].map(function (descItem, i) {
              return (
                <FadeInSection delay={`${i + 1}00ms`}>
                  <li key={i}>{descItem}</li>
                </FadeInSection>
              );
            })}
          </ul>
        </TabPanel>
      ))}
    </div>
  );
};

export default JobList;
